<div class="h1">Discounts or exemption</div>
<app-form-field label="Choose what applies" [includeMargin]="false">
  <app-radio [options]="[DiscountSelection.NO_DISCOUNT, DiscountSelection.DISCOUNT, DiscountSelection.EXEMPTION]"
             [formControl]="selectedType" [formatter]="formatSelectionType" [inline]="true" required></app-radio>
</app-form-field>
@switch (selectedType.value) {
  @case (DiscountSelection.DISCOUNT) {
    <div class="card mt-4">
      <div class="card-body p-4">
        <div class="row g-4">
          <p class="mb-0">
            You must choose between two discount types: a discount for registered and approved liner services, or a
            discount for frequent
            visits where at least 50% of the cargo is agribulk. Other discounts like the ESI incentive will be applied
            automatically.
          </p>
          <div class="col-12">
            <app-form-field label="Discount type" [includeMargin]="false">
              <app-radio [options]="discountTypeOptions" [formControl]="discountForm.controls.discountType"
                         [inline]="true" [formatter]="formatDiscountType" [required]="true"></app-radio>
              <div class="invalid-feedback">Discount type is required</div>
            </app-form-field>
          </div>
          @if (isLinerOrAgriBulk()) {
            @if (linerOptions.length > 0) {
              <div class="col-6">
                <div class="card">
                  <div class="card-body p-4">
                    <div class="row g-4">
                      @if (isLiner()) {
                        <app-form-field class="col-12" label="Voyage type" [includeMargin]="false">
                          <app-radio [formControl]="discountForm.controls.shortSea" [options]="[true, false]"
                                     [inline]="true"
                                     [formatter]="formatShortSea" [required]="isLiner()"></app-radio>
                        </app-form-field>
                      }
                      <app-form-field class="col-12" label="Liner service" [includeMargin]="false">
                        <app-search [options]="linerOptions"
                                    [inputFormatter]="linerFormatter"
                                    [formControl]="discountForm.controls.linerService"
                                    [placeholder]="'Type to search'"
                                    [required]="discountSelected() && isLinerOrAgriBulk()">
                        </app-search>
                      </app-form-field>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <app-status-alert type="danger" [closeable]="false">
                <div class="row gx-3">
                  <div class="col-auto d-flex align-items-center">
                    <i class="fal fa-times-circle text-danger-dark fs-2"></i>
                  </div>
                  <div class="col d-flex flex-column justify-content-center">
                    <div class="fw-medium mb-1">
                      No liner service registered
                    </div>
                    <div class="row gx-1">
                      No registered liner service was found for {{ carrierName() }}. The discount will not be applied.
                      If this is incorrect, contact Portbase Support.
                    </div>
                  </div>
                </div>
              </app-status-alert>
            }
          }
          <div class="col-12">
            <app-form-field label="Green Award discount" [includeMargin]="false">
              <span class="text-muted">Does the vessel hold a valid Green Award certificate</span>
              <app-yes-no [required]="discountSelected()"
                          [formControl]="discountForm.controls.greenAward"></app-yes-no>
              <div class="invalid-feedback">Please answer the question with yes or no</div>
            </app-form-field>
          </div>
        </div>
      </div>
    </div>
  }
  @case (DiscountSelection.EXEMPTION) {
    <div class="card mt-4">
      <div class="card-body p-4">
        <div class="row g-4">
          <app-form-field class="col-12" label="Exemption type" [includeMargin]="false">
            <p class="text-muted">
              <span>Select the exemption based on your vessel type or visit purpose as defined in </span>
              <a class="link-primary text-decoration-underline" target="_blank"
                 href="https://www.portofamsterdam.com/en/shipping/sea-shipping/harbour-dues">
                section 8.1 of the Sea Harbour Dues.
              </a>
            </p>
            <app-search [options]="Object.values(HarbourDuesExemption)" [formControl]="exemption"
                        [placeholder]="'Type to search'" [required]="exemptionSelected()"
                        [inputFormatter]="exemptionArt81CodeFormatter" [resultTemplate]="rt"></app-search>
            @if (exemption?.value) {
              <div class="card mt-3">
                <div class="card-body p-3">
                  <div>{{ exemptionArt81CodeFormatter(exemption.value) }}</div>
                </div>
              </div>
            }
          </app-form-field>
        </div>
      </div>
    </div>
  }
  @default {
    <div></div>
  }
}

<ng-template #rt let-r="result">
  <div class="result-template w-100">{{ exemptionArt81CodeFormatter(r) }}</div>
</ng-template>
